export const cacheAllQueries = operation => JSON.stringify(operation);
export const dontCache = () => null;

const cacheMiddleware = (cacheStorage, generateCacheKey = cacheAllQueries) => next => (
	operation,
	context,
) => {
	const cacheKey = generateCacheKey(operation);

	if (cacheKey == null) return next(operation, context);

	const cacheData = cacheStorage.get(cacheKey);
	if (cacheData != null) {
		return Promise.resolve(cacheData);
	}

	return next(operation, context).then(results => {
		cacheStorage.set(cacheKey, results);
		return results;
	});
};

export default cacheMiddleware;
